"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXTRA_FIELDS_KEY = void 0;
/* Property name to prepend to each hardware custom field */
exports.EXTRA_FIELDS_KEY = 'x_field';
